import { createContext } from "react";
import type { UploadContextValue } from "../types/UploadType";

export const UploadContext = createContext<UploadContextValue | undefined>(undefined);